export default __webpack_public_path__ + "static/media/Signature-Image.c963e38f.png";